import React from 'react';
import './tags.scss';

const Tags = ({data}) => (
  <div className="tags">
    {data.map(({name, code}) => (
      <div key={code} className="tag">
        <span>#</span> {name}
      </div>
    ))}
  </div>
);

export default Tags;
